import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams, Navigate } from "react-router-dom";
import { useWeb3 } from "../../context/Web3Context";
import { useContract } from "../../hooks/useContract";
import { toast } from "react-toastify";
import "./Register.css";

export default function Register() {
  const { account } = useWeb3();
  const contracts = useContract();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [name, setName] = useState("");
  const [refId, setRefId] = useState("");
  const [refName, setRefName] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const ref = searchParams.get("ref");
    if (ref) {
      setRefId(ref);
    }
  }, [searchParams]);

  useEffect(() => {
    if (refId && contracts) fetchRefName();
    // eslint-disable-next-line
  }, [refId, contracts]);

  async function fetchRefName(val) {
    try {
      const rid = parseInt(val || refId);
      if (!rid) { setRefName(""); return; }
      const info = await contracts.data.getUserInfo(rid);
      if (info.wallet === "0x0000000000000000000000000000000000000000") {
        setRefName("");
      } else {
        setRefName(info.name || "");
      }
    } catch {
      setRefName("");
    }
  }

  async function handleRegister(e) {
    e.preventDefault();
    if (!contracts) {
      toast.error("Contracts not loaded. Check network config.");
      return;
    }
    if (!name.trim()) {
      toast.error("Name is required");
      return;
    }

    setLoading(true);
    try {
      const refNum = parseInt(refId) || 0;
      const tx = await contracts.data.register(refNum, name.trim());
      toast.info("Transaction submitted. Waiting for confirmation...");
      await tx.wait();
      toast.success("Registration successful!");
      // Small delay to let the toast show, then hard navigate to avoid stale state
      setTimeout(() => { window.location.href = "/home"; }, 1000);
    } catch (err) {
      const msg = err.reason || err.message || "Registration failed";
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  }

  if (!account) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="register-page">
      <div className="register-card">
        <h2 className="register-title">Create Account</h2>
        <p className="register-sub">Register to start earning with Global Share</p>

        <form onSubmit={handleRegister} className="register-form">
          <div className="form-group">
            <label className="form-label">Your Name</label>
            <input
              type="text"
              className="form-input"
              placeholder="Enter your name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label className="form-label">Sponsor ID</label>
            <input
              type="text"
              className="form-input"
              placeholder="Enter sponsor ID"
              value={refId}
              onChange={(e) => { setRefId(e.target.value); if (contracts) fetchRefName(e.target.value); }}
              disabled={loading}
            />
            {refName && (
              <span className="form-ref-name">Sponsor: {refName} (ID: {refId})</span>
            )}
            {!refName && refId && (
              <span className="form-hint">Leave empty to use default sponsor</span>
            )}
          </div>

          <button type="submit" className="btn-neon register-btn" disabled={loading || !name.trim()}>
            {loading ? "Registering..." : "Register Now"}
          </button>
        </form>
      </div>
    </div>
  );
}
